var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.549,
    height: 37.549,
    viewBox: "0 0 37.549 37.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-whatsapp",
    "data-name": "Icon awesome-whatsapp",
    d: "M31.925,7.706A18.613,18.613,0,0,0,2.64,30.16L0,39.8l9.865-2.59a18.55,18.55,0,0,0,8.893,2.263h.008A18.786,18.786,0,0,0,37.549,20.865,18.68,18.68,0,0,0,31.925,7.706ZM18.766,36.337a15.438,15.438,0,0,1-7.878-2.154l-.562-.335-5.85,1.534,1.559-5.708-.369-.587a15.5,15.5,0,1,1,28.74-8.222,15.638,15.638,0,0,1-15.64,15.472Zm8.482-11.583c-.461-.235-2.749-1.358-3.177-1.509s-.738-.235-1.048.235-1.2,1.509-1.475,1.827-.545.352-1.006.117c-2.732-1.366-4.526-2.439-6.328-5.532-.478-.821.478-.763,1.366-2.54a.862.862,0,0,0-.042-.813c-.117-.235-1.048-2.523-1.433-3.453-.377-.905-.763-.779-1.048-.8-.268-.017-.578-.017-.888-.017a1.722,1.722,0,0,0-1.24.578A5.224,5.224,0,0,0,9.3,16.733,9.108,9.108,0,0,0,11.2,21.544c.235.31,3.277,5,7.946,7.024,2.95,1.274,4.107,1.383,5.582,1.165.9-.134,2.749-1.123,3.135-2.213a3.888,3.888,0,0,0,.268-2.213C28.019,25.1,27.709,24.98,27.248,24.754Z",
    transform: "translate(0 -2.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappicon);
export default __webpack_public_path__ + "static/media/whatsappicon.7985341d14165c28d73e0929b8a934f5.svg";
export { ForwardRef as ReactComponent };